import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_REALTIME_SESSION = gql(`
	mutation CreateRealtimeSession {
		createRealtimeSession
	}
`);

export const GET_INSTRUCTIONS = gql(`
	query AiAssistantInstructions {
		getInstructions {
			catalog
			books
			plans
			schedule
		}
	}
`);
